import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;

/**
 * 检查内容库管理API服务
 */
export const checkContentService = {
  /**
   * 查询检查内容列表（不分页）
   */
  listCheckContents: (params) => axios.get(`${iffApi}/checkContent/list`, { params: params }),

  /**
   * 分页查询检查内容
   */
  queryCheckContentPage: (params) => axios.get(`${iffApi}/checkContent/page`, { params: params }),

  /**
   * 保存
   */
  addCheckContent: (data) => axios.post(`${iffApi}/checkContent/save`, data),

  updateCheckContent: (data) => axios.post(`${iffApi}/checkContent/update`, data),

  /**
   * 删除
   */
  deleteCheckContent: (uuid) => axios.delete(`${iffApi}/checkContent/delete/${uuid}`),

  /**
   * 批量删除
   */
  batchDeleteCheckContent: (uuids) => axios.post(`${iffApi}/checkContent/batchDelete`, uuids),

  /**
   * 获取统计信息
   */
  getCheckContentStats: () => axios.get(`${iffApi}/checkContent/stats`, { params: { } }),

  /**
   * 下载导入模板
   */
  downloadTemplate: () => axios.get(`${iffApi}/checkContent/getExcelMb`, { responseType: 'blob' }),

  /**
   * 导入检查内容
   */
  importCheckContent: (formData) => axios.post(`${iffApi}/checkContent/importExcel`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),

  /**
   * 导出检查内容
   */
  exportCheckContent: (params) => axios.post(`${iffApi}/checkContent/exportExcel`, params, { responseType: 'blob' })
};
